module.exports = __webpack_public_path__ + "img/ig.1d900d8f.png";